/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type MeasurementUnit = "CM" | "IN" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuDimensionUnitRadioSelect_user$ref: FragmentReference;
export type SbSharedRefineMenuDimensionUnitRadioSelect_user = {|
  +serviceId: ?string,
  +profile: ?{|
    +measurementUnit: ?MeasurementUnit
  |},
  +$refType: SbSharedRefineMenuDimensionUnitRadioSelect_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuDimensionUnitRadioSelect_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "measurementUnit",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'fc2b7ccc2ef5138d191d7dc53da11515';
module.exports = node;
